"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrfTextItemTransformPattern = exports.StudyUnblindRequestType = exports.SubjectStatisticsMode = void 0;
exports.SubjectStatisticsMode = {
    Cumulative: "CUMULATIVE",
    Periodic: "PERIODIC",
};
var StudyUnblindRequestType;
(function (StudyUnblindRequestType) {
    StudyUnblindRequestType["ApprovalRequired"] = "APPROVAL_REQUIRED";
    StudyUnblindRequestType["UnderConditionsWithoutApproval"] = "UNDER_CONDITIONS_WITHOUT_APPROVAL";
    StudyUnblindRequestType["WithoutApproval"] = "WITHOUT_APPROVAL";
})(StudyUnblindRequestType = exports.StudyUnblindRequestType || (exports.StudyUnblindRequestType = {}));
var CrfTextItemTransformPattern;
(function (CrfTextItemTransformPattern) {
    CrfTextItemTransformPattern["OnlyEnglish"] = "ONLY_ENGLISH";
    CrfTextItemTransformPattern["OnlyEnglishAndNumber"] = "ONLY_ENGLISH_AND_NUMBER";
    CrfTextItemTransformPattern["AlphanumericAndSpecialChar"] = "ALPHANUMERIC_AND_SPECIAL_CHAR";
})(CrfTextItemTransformPattern = exports.CrfTextItemTransformPattern || (exports.CrfTextItemTransformPattern = {}));
//# sourceMappingURL=crf.js.map